import { Icon, ICONS } from './icon';

import css from './faq-list.module.css';

export type FaqEntry = { q: string; a: string };

/**
 * An FAQ as `<details>` rows (no client state, so it renders the same before
 * and after hydration). Pages mirror the same entries as FAQPage JSON-LD
 * (faqPageJsonLd) — build both from one list.
 */
export function FaqList({ entries }: { entries: FaqEntry[] }) {
  return (
    <div className={css.list}>
      {entries.map((entry) => (
        <details key={entry.q} className={css.item}>
          <summary className={css.question}>
            <h3 className={css.heading}>{entry.q}</h3>
            <Icon d={ICONS.chevronDown} size={18} className={css.icon} />
          </summary>
          <p className={css.answer}>{entry.a}</p>
        </details>
      ))}
    </div>
  );
}
